// eslint-disable-next-line import/prefer-default-export
export const PHONE_REGEX = /\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
